import { animate, state, style, transition, trigger } from '@angular/animations';

export const expandCollapseAnimation = trigger('expandCollapseAnimation', [
  state('true', style({ height: '*', overflow: 'hidden' })),
  state('false', style({ height: '0px', overflow: 'hidden' })),
  transition('false <=> true', animate('225ms cubic-bezier(0.4,0.0,0.2,1)')),
]);
